export const WEB = 'WEB';
export const DROID = 'DROID';
export const MOB = 'MOB';
